module.exports = __webpack_public_path__ + "static/media/ass.4f172bc6.jpg";